import { GET_TASK, GET_TASKS } from "../actions/types";

const initialState = {
  task: {},
  tasks: [],
};
export default function task(state = initialState, action) {
  switch (action.type) {
    case GET_TASK:
      return {
        ...state,
        task: action.payload,
      };
    case GET_TASKS:
      return {
        ...state,
        tasks: action.payload,
      };
    default:
      return state;
  }
}
